var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowmsgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.90625C17.8848 3.90625 22.2656 7.40273 22.2656 11.7008C22.2656 15.9988 17.8848 19.4949 12.5 19.4949C12.2477 19.4949 11.9879 19.4863 11.7254 19.4695C8.84688 21.6195 6.48672 21.9113 6.38477 21.923C6.35508 21.9266 6.32539 21.9281 6.2957 21.9281C6.02227 21.9281 5.76602 21.7844 5.62383 21.5457C5.4668 21.2809 5.47969 20.9488 5.65664 20.6973C5.66563 20.6844 6.42461 19.6035 7.22031 18.2621C4.43203 16.8375 2.73438 14.3855 2.73438 11.7008C2.73438 7.40273 7.11523 3.90625 12.5 3.90625ZM12.5 17.9324C17.023 17.9324 20.7031 15.1367 20.7031 11.7004C20.7031 8.26406 17.023 5.46875 12.5 5.46875C7.97695 5.46875 4.29688 8.26445 4.29688 11.7008C4.29688 13.9898 5.95391 16.0926 8.62148 17.1875C8.82812 17.2723 8.98828 17.4414 9.06211 17.6523C9.13594 17.8633 9.11602 18.0957 9.00664 18.2906C8.71406 18.8152 8.4125 19.3199 8.1332 19.7699C8.93828 19.423 9.93594 18.8832 11.0094 18.0508C11.1648 17.9297 11.3609 17.8719 11.5562 17.8898C11.8785 17.9184 12.1961 17.9324 12.5 17.9324Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowmsgImg);
export default __webpack_public_path__ + "static/media/flowmsgImg.1c62f666a7d74e3bf05ebc76ce7c1e31.svg";
export { ForwardRef as ReactComponent };